import { render, staticRenderFns } from "./batchnoStockList.vue?vue&type=template&id=0822465b"
import script from "./batchnoStockList.vue?vue&type=script&lang=js"
export * from "./batchnoStockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports